import _ from "lodash";
import parseImageId from "./parseImageId";
import loadFileRequest from "./loadFileRequest.js";
import { xhrRequest } from "../internal/index.js";
import Cache from "core/cache/index";
import Loader from "core/loader/index";
import Memory from "core/performance";
import Helper from "helper/index";
import Config from "config";
import WebWorkerManager from "../webworker/webWorkerManager.js";
import FloatMessageBox from "core/messageBoxController/index";
import LoadingSnackbarManager from "component/atoms/loadingSnackbar/loadingSnackbarManager";
import taskHandler from "../webworker/loaderTask";

const LIMIT_XHR_REQUEST_COUNT = 200;
const CurrentRequestCount = 0;

function isLoadComplete(loadedFiles, totalFiles) {
  if (loadedFiles === totalFiles) {
    //LoadingSnackbarManager.complete("Complete", 3000);
    return true;
  }
  return false;
}

function getLoaderForScheme(scheme) {
  if (scheme === "dicomweb" || scheme === "wadouri") {
    return xhrRequest;
  } else if (scheme === "dicomfile") {
    return loadFileRequest;
  }
}

async function get(urls, options) {
  ///
  /// 0. 입력 데이터가 없다면, 함수를 종료
  ///
  const totalFiles = urls.length;
  if (totalFiles === 0) {
    return;
  }
  /**
   * 1. Check memory
   * @ref @site : https://stackoverflow.com/questions/23506064/how-do-you-detect-memory-limits-in-javascript
   */
  const hasFreeMemory = Memory.hasFreeMemoryCapacity(30000000 /**30mb */);

  if (hasFreeMemory === false) {
    FloatMessageBox({
      title: "Warning",
      message:
        "The data cannot be loaded.\r\n The memory usage has reached the limit."
    });
    return;
  }

  LoadingSnackbarManager.loading("Loading", -1);
  var t0 = performance.now();

  let loadedFiles = 0;
  const chunckSize = 20;
  const cacheChunks = new Array(Math.ceil(urls.length / chunckSize))
    .fill()
    .map(_ => {
      return urls.splice(0, chunckSize);
    });
  for (let chunk of cacheChunks) {
    await Promise.all(
      // eslint-disable-next-line no-loop-func
      chunk.map(async function(url) {
        // eslint-disable-next-line no-unused-expressions
        WebWorkerManager.addTask(
          "fetchDICOM",
          url,
          // eslint-disable-next-line no-undef
          0
        ).promise;
      })
    ).then(() => {
      var t2 = performance.now();
      console.log("WebWorker loading Complete  " + (t2 - t0) / 1000 + " sec");
      LoadingSnackbarManager.complete("Complete", 3000);
      Config.rootStore.seriesListStore.updateThumbnails();
    });
  }
}

const WadoURIProvider = {
  get
};
export default WadoURIProvider;
